import axios from '../../axios-config'
/**
 * POST
 * /discover/api/v1/enrich
 * doEnrichment
 */
export const doEnrichment = (payload) => {
  return axios.post('/discover/api/v1/enrich', payload)
}
